const isChainedKey = (baseKey, targetKey) => {
  if (!baseKey || !targetKey) return false;
  const baseParts = baseKey.split('.');
  const targetParts = targetKey.split('.');
  if (baseParts.length >= targetParts.length) return false;
  return baseParts.every((part, index) => part === targetParts[index]);
};

export default isChainedKey;
